
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import ProductQuantity from '@/components/ProductQuantity.vue';
import BasketModule from '@/store/modules/basket';
import { hideCMSContent } from '@/utils/global.util';
import { getSelectedProductChoicesDisplay } from '@/utils/products.util';

@Component({
  components: {
    ProductQuantity
  },
})
export default class ProductsSummary extends Vue {
    @Prop() products: any[];
    @Prop({ default: false }) allowModifications: boolean;
    @Getter categories!: Category[];

    selectedProductChoicesDisplay(basketProduct: BasketProduct) {
      return getSelectedProductChoicesDisplay(basketProduct);
    }

    @Emit('close-drawer')
    handleEditBasketProduct(basketProductId, productId) {
      hideCMSContent();

      const product = this.getProductFromProductId(productId);
      this.$router.push(
        {
          name: 'ProductEdit',
          params: {
            ...this.$route.params,
            categorySlug: product.categorySlug,
            productSlug: product.slug,
            basketProductId: basketProductId.toString(),
          },
        });
    }

    getProductFromProductId(productId) {
      return this.categories.reduce((acc, cat) => {
        const p = cat.products.find((pro) => pro.id === parseInt(productId, 10));
        if (p) {
          acc = p;
        }
        return acc;
      }, {} as Product);
    }

    async handleRemoveBasketProduct(id) {
      await BasketModule.removeItem({ basketId: BasketModule.id, basketProductId: id });
    }
}
